export default "__VITE_ASSET__9badd70d__"